/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_ImportInputs */

const en_zotero_browser_import = /** @type {(inputs: Zotero_Browser_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const es_zotero_browser_import = /** @type {(inputs: Zotero_Browser_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Zotero_Browser_ImportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_import = /** @type {((inputs?: Zotero_Browser_ImportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_ImportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_import(inputs)
	return en_zotero_browser_import(inputs)
});